import { render, staticRenderFns } from "./BoxImage.vue?vue&type=template&id=c0837eb0&scoped=true&"
import script from "./BoxImage.vue?vue&type=script&lang=js&"
export * from "./BoxImage.vue?vue&type=script&lang=js&"
import style0 from "./BoxImage.vue?vue&type=style&index=0&id=c0837eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0837eb0",
  null
  
)

export default component.exports